import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, ArrowLeft } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("ht_token", data.access_token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const fieldCls =
    "bg-[#0A0A0A] border-[#262626] focus-visible:border-[#0055FF] focus-visible:ring-0 text-white rounded-none h-12";

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <a href="/" data-testid="back-home-link" className="inline-flex items-center gap-2 text-sm text-[#A3A3A3] hover:text-white mb-8 transition-colors">
          <ArrowLeft size={16} /> Back to site
        </a>
        <div className="mb-8">
          <div className="font-display font-bold text-2xl tracking-tight text-white">HOWELL</div>
          <div className="text-xs uppercase tracking-[0.3em] text-[#0055FF] font-bold">Coach Dashboard</div>
        </div>
        <form data-testid="admin-login-form" onSubmit={submit} className="bg-[#141414] border border-[#262626] p-8 space-y-5">
          <h1 className="font-display font-semibold text-xl text-white">Sign In</h1>
          <div className="space-y-2">
            <Label className="text-xs uppercase tracking-widest text-[#A3A3A3] font-bold">Email</Label>
            <Input data-testid="admin-email-input" type="email" className={fieldCls} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="ryan@howelltransformations.com" />
          </div>
          <div className="space-y-2">
            <Label className="text-xs uppercase tracking-widest text-[#A3A3A3] font-bold">Password</Label>
            <Input data-testid="admin-password-input" type="password" className={fieldCls} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm text-red-400">{error}</p>}
          <button
            type="submit"
            data-testid="admin-login-button"
            disabled={loading}
            className="w-full bg-[#0055FF] text-white hover:bg-[#3377FF] transition-colors font-bold px-8 py-3 uppercase tracking-wide flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading ? <><Loader2 size={18} className="animate-spin" /> Signing in...</> : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
